import { Controller } from '@hotwired/stimulus'
import Lenis from 'lenis'

export default class extends Controller {
    #lenis = null

    connect() {
        this.#lenis = new Lenis({
            autoRaf: true,
            wrapper: this.element,
        })
    }

    disconnect() {
        this.#lenis.destroy()
    }
}
